import React from 'react';
import { useLocation } from 'react-router-dom';
import ComingSoon from './ComingSoon';
import { getModuleName, normalizeModulePath } from '../config/comingSoonRoutes';
import { usePermissions } from '../context/PermissionsContext';

/**
 * Wrapper que muestra "Coming Soon" si la ruta actual está marcada como oculta.
 * Consume la fuente de verdad centralizada en PermissionsContext.
 */
const ProductionGate = ({ children }) => {
  const location = useLocation();
  const { isModuleMuyPronto, loaded } = usePermissions();

  // Mientras carga, no mostrar nada (evita flash)
  if (!loaded) return null;

  const modulePath = normalizeModulePath(location.pathname);

  // 'Muy pronto': visible en el sidebar pero tapado con la pantalla de coming-soon.
  // 'Oculto' NO se tapa aquí: solo sale del sidebar. El acceso por link lo controla
  // Permisos por Rol (PrivateRoute redirige a /inicio si el rol no tiene el módulo).
  if (isModuleMuyPronto(modulePath)) {
    return <ComingSoon moduleName={getModuleName(modulePath)} />;
  }

  return children;
};

export default ProductionGate;
